import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useGetEmrsQuery } from '~/api/v2/hooks';
import { DATE_FORMAT } from '~/utils';
import { detailsContainerStyles } from './styles';

const EmrDetails = () => {
  const projectId = +useParams().projectid!;
  const { data } = useGetEmrsQuery({ projectId });

  const detailsFields = [
    {
      name: 'STUDIO NAME',
      value: data?.name,
    },
    {
      name: 'STUDIO ID',
      value: data?.aws_studio_id,
    },
    {
      name: 'CREATION DATE',
      value: data?.created ? format(new Date(data.created), DATE_FORMAT) : '—',
    },
  ];

  return (
    <Box sx={detailsContainerStyles}>
      <Box display="flex" gap="3rem">
        {detailsFields.map(({ name, value }) => (
          <Box key={name}>
            <Typography variant="eyebrowDefault" color="#0000008C">
              {name}
            </Typography>
            <Typography>{value}</Typography>
          </Box>
        ))}
      </Box>
      <Box>
        <Typography variant="button" color="#0000008C">
          DESCRIPTION
        </Typography>
        <Typography sx={{ wordBreak: 'break-word' }}>{data?.description || '—'}</Typography>
      </Box>
    </Box>
  );
};

export default EmrDetails;
